const initialiseBagPage = () => {
  window.addEventListener("load", () => {
    // https://www.glamcorner.com.au/checkout/cart
    // Currently not in use
    if (document.querySelector("body").classList.contains("checkout-cart-index")) {
      import("./BagPage").then((importedModule) => {
        new importedModule.default().initialise(GC.data.products, GC.data.postcode);
      });
    }
  });
};

export { initialiseBagPage };
